export default __webpack_public_path__ + "static/media/nf-700.13d4cff6.webp";